// DATAVIB services data — used both for landing grid and per-service detail pages.

export const SERVICES = [
  {
    slug: "titresim-olcum-analiz-raporlama",
    galleryKey: "vibration-analysis",
    code: "S-01",
    title: "Titreşim Ölçüm, Analiz ve Raporlama",
    short: "ISO 10816 / 20816 yaklaşımıyla saha ölçümü, FFT analizi, hata teşhisi ve teknik raporlama.",
    icon: "Activity",
    image: "/images/service-vibration.jpg",
    delivers: [
      "Standartlara uygun saha ölçümü (ISO 10816 / 20816 yaklaşımı)",
      "Spektrum (FFT), zaman dalga formu, zarflama (envelope) analizi",
      "Rulman, dengesizlik, hizalama, gevşeklik, elektriksel arıza teşhisi",
      "Önceliklendirilmiş aksiyon listesi içeren teknik PDF rapor",
    ],
    equipment: ["Elektrik motorları", "Fanlar / blowerlar", "Pompalar", "Redüktörler", "Kompresörler", "Tamburlar"],
    process: ["Ekipman envanteri ve kritiklik haritası", "Ölçüm noktalarının belirlenmesi", "Saha ölçümü", "Analiz + raporlama"],
  },
  {
    slug: "online-condition-monitoring",
    galleryKey: "condition-monitoring",
    code: "S-02",
    title: "Online Condition Monitoring Sistemleri",
    short: "Kritik ekipmanlarda 7/24 izleme: sensör seçimi, kurulum, devreye alma ve alarm yönetimi.",
    icon: "Radio",
    image: "/images/service-condition-monitoring.jpg",
    delivers: [
      "Kritik ekipmanlar için online izleme tasarımı",
      "Titreşim, sıcaklık, hız ve proses parametrelerinin sürekli takibi",
      "Alarm seviyelerinin (alert / danger) konfigürasyonu",
      "SCADA / CMMS entegrasyonu ve uzaktan görüntüleme",
    ],
    equipment: ["Kritik fanlar", "Ana hat motorları", "Türbinler", "Yüksek devirli pompalar"],
    process: ["Ekipman kritiklik analizi", "Sensör + DAQ donanım seçimi", "Saha kurulumu", "Devreye alma + eğitim"],
  },
  {
    slug: "yerinde-balans",
    galleryKey: "on-site-balancing",
    code: "S-03",
    title: "Yerinde Fan / Tambur Balans",
    short: "Sökmeden, sahada tek/çift düzlem dinamik balans alımı ve doğrulama raporu.",
    icon: "Disc3",
    image: "/images/service-balancing.jpg",
    delivers: [
      "Tek ve çift düzlem dinamik balans",
      "ISO 21940 yaklaşımıyla artık dengesizlik değerlendirmesi",
      "Öncesi / sonrası titreşim kıyas raporu",
      "Sahada uygulama — ekipman sökümüne gerek yok",
    ],
    equipment: ["Endüstriyel fanlar", "Aspiratörler", "Tamburlar", "Rotorlar"],
    process: ["Mevcut titreşim ölçümü", "Etki katsayısı belirleme", "Ağırlık ekleme / kaldırma", "Doğrulama ölçümü"],
  },
  {
    slug: "lazerli-saft-hizalama",
    galleryKey: "shaft-alignment",
    code: "S-04",
    title: "Lazerli Şaft Hizalama (Kaplin Ayarı)",
    short: "Lazer hizalama cihazları ile yüksek hassasiyetli kaplin ayarı ve toleransa göre raporlama.",
    icon: "Crosshair",
    image: "/images/service-alignment.jpg",
    delivers: [
      "Lazer hizalama cihazıyla yüksek hassasiyetli kaplin ayarı",
      "Yumuşak ayak (soft foot) tespiti ve düzeltme",
      "Termal büyüme kompansasyonu",
      "Tolerans değerlendirmeli hizalama raporu",
    ],
    equipment: ["Motor – pompa kaplinleri", "Motor – fan kaplinleri", "Motor – redüktör hatları"],
    process: ["Ön kontrol (yumuşak ayak)", "Ölçüm", "Düzeltme (shim / yatay)", "Doğrulama"],
  },
  {
    slug: "fan-bakimi-revizyonu",
    galleryKey: "fan-service",
    code: "S-05",
    title: "Fan Bakımı, Revizyonu ve İmalatı",
    short: "Endüstriyel fanlarda kapsamlı bakım, revizyon, kanat imalatı ve performans doğrulama.",
    icon: "Wind",
    image: "/images/service-fan.jpg",
    delivers: [
      "Komple fan revizyonu ve rulman değişimi",
      "Aşınmış kanat / salyangoz onarımı veya yenisinin imalatı",
      "Devreye alma sonrası balans + titreşim doğrulama",
      "Bakım sonrası performans raporu",
    ],
    equipment: ["Aspiratörler", "Cebri çekiş fanları", "Radyal / aksiyal fanlar", "Toz toplama fanları"],
    process: ["Demontaj + ekspertiz", "Yedek parça / imalat", "Montaj", "Balans + devreye alma"],
  },
  {
    slug: "pompa-bakimi-revizyonu",
    galleryKey: "pump-service",
    code: "S-06",
    title: "Pompa Bakımı ve Revizyonu",
    short: "Santrifüj ve pozitif yer değiştirmeli pompalarda revizyon, salmastra ve performans doğrulama.",
    icon: "Droplets",
    image: "/images/service-pump.jpg",
    delivers: [
      "Santrifüj ve pozitif yer değiştirmeli pompa revizyonu",
      "Salmastra, mekanik salmastra ve rulman değişimi",
      "İmpeller kontrolü ve aşınma analizi",
      "Devreye alma sonrası titreşim ve performans doğrulama",
    ],
    equipment: ["Santrifüj pompalar", "Vakum pompaları", "Dozaj pompaları", "Sirkülasyon pompaları"],
    process: ["Demontaj + ekspertiz", "Parça yenileme", "Montaj + hizalama", "Devreye alma testi"],
  },
  {
    slug: "makine-tasima-montaj",
    galleryKey: "machine-installation",
    code: "S-07",
    title: "Makine Taşıma, Montaj ve Devreye Alma",
    short: "Hat içi makine sökümü, taşınması, yeni hatta montajı ve devreye alma süreçleri.",
    icon: "Truck",
    image: "/images/service-installation.jpg",
    delivers: [
      "Hat içi makine söküm planı ve uygulama",
      "Taşıma, kaldırma ve sabitleme işlemleri",
      "Yeni hatta montaj, hizalama ve devreye alma",
      "Devreye alma sonrası titreşim doğrulama",
    ],
    equipment: ["Üretim hatları", "Hidrolik / pnömatik üniteler", "Fan ve pompa grupları", "Konveyör sistemleri"],
    process: ["Saha keşfi + risk planı", "Söküm + taşıma", "Montaj + hizalama", "Devreye alma + doğrulama"],
  },
  {
    slug: "endustriyel-otomasyon",
    galleryKey: "industrial-automation",
    code: "S-08",
    title: "Endüstriyel Otomasyon (PLC / SCADA)",
    short: "PLC programlama, SCADA görselleştirme, panel imalatı ve mevcut hatların modernizasyonu.",
    icon: "Cpu",
    image: "/images/service-automation.jpg",
    delivers: [
      "PLC programlama (Siemens, Allen-Bradley, Mitsubishi vb.)",
      "SCADA / HMI görselleştirme ve raporlama",
      "Pano tasarımı, imalatı ve devreye alma",
      "Mevcut hatların modernizasyonu (retrofit)",
    ],
    equipment: ["Üretim hatları", "Proses tankları", "Konveyör sistemleri", "Su / hava şartlandırma sistemleri"],
    process: ["İhtiyaç analizi", "Donanım + yazılım tasarımı", "Pano + saha kurulumu", "Devreye alma + eğitim"],
  },
];

export const SERVICE_BY_SLUG = Object.fromEntries(SERVICES.map(s => [s.slug, s]));
